import { render, staticRenderFns } from "./RulesModal.vue?vue&type=template&id=f684e4a0&scoped=true&"
import script from "./RulesModal.vue?vue&type=script&lang=js&"
export * from "./RulesModal.vue?vue&type=script&lang=js&"
import style0 from "./RulesModal.vue?vue&type=style&index=0&id=f684e4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f684e4a0",
  null
  
)

export default component.exports